<div class="dialog-header-container d-flex align-items-center justify-content-between p-3 border-bottom">
  <h2 mat-dialog-title class="m-0 fs-5 fw-bold text-dark">Options d'impression</h2>
  @if (state()) { <mat-spinner diameter="20" class="spinner-light"></mat-spinner>}
  <button mat-icon-button mat-dialog-close aria-label="Fermer la boîte de dialogue">
    <mat-icon class="text-muted">close</mat-icon>
  </button>
</div>

<mat-dialog-content id="modalDialog" #modalDialog class="p-4 bg-light">
  <div class="print-actions-grid">
    
    <button [disabled]="state()" mat-ripple class="print-grid-btn" (click)="printService.imprimer(data.id)">
      <div class="btn-icon-wrapper ctx-contract">
        <mat-icon>description</mat-icon>
      </div>
      <div class="btn-text-wrapper">
        <span class="btn-main-title">Contrat</span>
        <span class="btn-sub-title">Imprimer le contrat</span>
      </div>
    </button>

    <button [disabled]="state()" mat-ripple class="print-grid-btn" (click)="printService.imprimerRecu(data.id)">
      <div class="btn-icon-wrapper ctx-receipt">
        <mat-icon>receipt_long</mat-icon>
      </div>
      <div class="btn-text-wrapper">
        <span class="btn-main-title">Reçu</span>
        <span class="btn-sub-title">Imprimer le reçu de paiement</span>
      </div>
    </button>

    <button [disabled]="state()" mat-ripple class="print-grid-btn" (click)="printService.imprimerAttestation(data.id)">
      <div class="btn-icon-wrapper ctx-badge">
        <mat-icon>badge</mat-icon>
      </div>
      <div class="btn-text-wrapper">
        <span class="btn-main-title">Attestation</span>
        <span class="btn-sub-title">Imprimer l'attestation</span>
      </div>
    </button>

    <button [disabled]="state()" mat-ripple class="print-grid-btn" (click)="printService.imprimerCarteRose(data.id)">
      <div class="btn-icon-wrapper ctx-card">
        <mat-icon>credit_card</mat-icon>
      </div>
      <div class="btn-text-wrapper">
        <span class="btn-main-title">Carte Rose</span>
        <span class="btn-sub-title">Imprimer la carte rose</span>
      </div>
    </button>

  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="p-3 border-top bg-white m-0">
  <button mat-stroked-button mat-dialog-close cdkFocusInitial color="warn" class="px-4">
    <span>Fermer</span>
  </button>
</mat-dialog-actions>
